import SocialCredential from "./base";

var BrightcoveCredential = SocialCredential.extend({
    parse: function (response) {
        response = BrightcoveCredential.__super__.parse.apply(this, arguments);

        response.name = response.brightcoveAccountName;
        response.profileImage = response.brightcoveProfileImageUrl;

        response.typeLabel = `Brightcove`;
        response.platformType = `Brightcove account`;

        return response;
    },

    onShareSuccessful: function (response) {
        return BrightcoveCredential.__super__.onShareSuccessful.call(
            this,
            `shareViaBrightcoveCount`,
            response
        );
    }
});

export default BrightcoveCredential;
